import { useState, useContext } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { BrowserContext } from "../../services/BrowserContext";

const ShareModal = ({ show, handleClose, path, token, expiresAt: initialExpiresAt }) => {
    const { itemsManipulator } = useContext(BrowserContext);
    const [password, setPassword] = useState('');
    const [expiresAt, setExpiresAt] = useState('');
    const apiUrl = new URL(process.env.REACT_APP_API_URL);
    const existingUrl = token ? `${apiUrl.origin}/share.php?token=${token}` : null;
    const [shareUrl, setShareUrl] = useState(null);
    const [copied, setCopied] = useState(false);
    const [editExpiresAt, setEditExpiresAt] = useState('');
    const [updateSuccess, setUpdateSuccess] = useState(false);

    const displayUrl = shareUrl || existingUrl;

    const handleSubmit = () => {
        itemsManipulator.createShare(path, password, expiresAt, (newToken) => {
            setShareUrl(`${apiUrl.origin}/share.php?token=${newToken}`);
            itemsManipulator.get(itemsManipulator.path);
        });
    };

    const handleUpdate = () => {
        itemsManipulator.updateShare(token, editExpiresAt, () => {
            setUpdateSuccess(true);
            setTimeout(() => setUpdateSuccess(false), 2000);
        });
    };

    const handleDelete = () => {
        itemsManipulator.deleteShare(token, () => {
            itemsManipulator.get(itemsManipulator.path);
            handleClose();
        });
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(displayUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const handleExited = () => {
        setPassword('');
        setExpiresAt('');
        setShareUrl(null);
        setCopied(false);
        setEditExpiresAt('');
        setUpdateSuccess(false);
    };

    const handleShow = () => {
        setEditExpiresAt(initialExpiresAt ? initialExpiresAt.slice(0, 16) : '');
    };

    return (
        <Modal show={show} onHide={handleClose} onExited={handleExited} onShow={handleShow} centered>
            <Modal.Header closeButton>
                <Modal.Title><i className="bi bi-share me-2"></i>Share</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {displayUrl ? (
                    <>
                        <p className="text-success mb-3">
                            <i className="bi bi-check-circle me-2"></i>
                            {shareUrl ? 'Link created successfully' : 'This item is already shared'}
                        </p>
                        <div className="input-group mb-3">
                            <input type="text" className="form-control" value={displayUrl} readOnly/>
                            <button className="btn btn-outline-secondary" onClick={handleCopy}>
                                <i className={`bi ${copied ? 'bi-check text-success' : 'bi-clipboard'}`}></i>
                            </button>
                        </div>
                        {existingUrl && (
                            <Form.Group>
                                <Form.Label>
                                    Expiration <span className="text-muted small">(optional)</span>
                                </Form.Label>
                                <div className="input-group">
                                    <Form.Control
                                        type="datetime-local"
                                        value={editExpiresAt}
                                        onChange={e => setEditExpiresAt(e.target.value)}
                                    />
                                    <button className="btn btn-outline-primary" onClick={handleUpdate}>
                                        {updateSuccess
                                            ? <i className="bi bi-check text-success"></i>
                                            : 'Update'
                                        }
                                    </button>
                                </div>
                            </Form.Group>
                        )}
                    </>
                ) : (
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                type="password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                placeholder="Required to access the link"
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>
                                Expiration <span className="text-muted small">(optional)</span>
                            </Form.Label>
                            <Form.Control
                                type="datetime-local"
                                value={expiresAt}
                                onChange={e => setExpiresAt(e.target.value)}
                            />
                        </Form.Group>
                    </Form>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Close</Button>
                {existingUrl && (
                    <Button variant="danger" onClick={handleDelete}>
                        <i className="bi bi-trash me-1"></i>Remove share
                    </Button>
                )}
                {!displayUrl && (
                    <Button variant="primary" onClick={handleSubmit} disabled={!password}>
                        <i className="bi bi-link-45deg me-1"></i>Generate link
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default ShareModal;
